import gql from "graphql-tag";

const UserPermissionQuery = gql`
    query UserPermissionQuery {
        userPermissions {
            permissions
        }
    }
`;

export default UserPermissionQuery;
